import GeocoderResult = google.maps.GeocoderResult;
import { Preorder } from './Preorder';

const GeocoderAddressComponentForm = {
	street_number: 'short_name',
	route: 'long_name',
	locality: 'long_name',
	administrative_area_level_1: 'long_name',
	country: 'short_name',
	postal_code: 'short_name',
};

export class Address {
	get isValid() {
		return this.street && this.number && this.postalCode && this.country;
	}
	name?: string;

	constructor(
		public street: string,
		public number: string,
		public postalCode: string,
		public state: string,
		public country: string,
		public city: string,
		public lng: number,
		public lat: number,
		public placeId?: string,
		public displayName?: string
	) {}

	static fromGeocode(place: GeocoderResult) {
		const addressData: any = {};

		for (const component of place.address_components) {
			const addressType = component.types[0];
			if (GeocoderAddressComponentForm[addressType]) {
				const val = component[GeocoderAddressComponentForm[addressType]];
				switch (addressType) {
					case 'route':
						addressData.street = val;
						break;
					case 'street_number':
						addressData.number = val;
						break;
					case 'postal_code':
						addressData.postalCode = val;
						break;
					case 'administrative_area_level_1':
						addressData.state = val;
						break;
					case 'country':
						addressData.country = val;
						break;
					case 'locality':
						addressData.city = val;
						break;
					default:
						break;
				}
			}
		}
		addressData.lng = place.geometry.location.lng();
		addressData.lat = place.geometry.location.lat();
		addressData.placeId = place.place_id;

		return new Address(
			addressData.street,
			addressData.number,
			addressData.postalCode,
			addressData.state,
			addressData.country,
			addressData.city,
			addressData.lng,
			addressData.lat,
			addressData.placeId
		);
	}

	static fromPreorder(preorder: Preorder) {
		return new Address(
			preorder.street,
			preorder.number,
			preorder.postalCode,
			preorder.state,
			preorder.country,
			preorder.city,
			+preorder.lng,
			+preorder.lat
		);
	}
}
